import { ActionsBar } from '../ActionsBar/ActionsBar';

export type SampleOrderContentProps = {
  pageContent: React.ReactNode;
  actionBarContent: React.ReactNode;
};

export const SampleOrderContent = ({ pageContent, actionBarContent }: SampleOrderContentProps) => (
  <>
    <div className="bg-color-grey-light relative z-5 p-2 lg:p-3">{pageContent}</div>
    <ActionsBar>{actionBarContent}</ActionsBar>
  </>
);
